import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AllAuthGuard } from './services/all-auth.service';

import { Tree,Node } from './directives/tree';
import { Treelist, Nodelist } from './directives/treelist';
import { DatePickerDirective } from './directives/datepicker';
import { TimePickerDirective } from './directives/timepickerr';
import { MenuService } from './directives/vnpt-menu.service';
import { TinyMceDirective } from './directives/tiny-editor-directive';
import { OnlyNumber } from './directives/isnumber';


import { DropdownModule, ModalModule,TypeaheadModule,TooltipModule, AccordionModule  } from 'ng2-bootstrap';

@NgModule({
    imports: [CommonModule, FormsModule, HttpModule, HttpModule],
    exports: [Treelist,Nodelist,TinyMceDirective,Tree,Node,DatePickerDirective,CommonModule, FormsModule, HttpModule,TimePickerDirective,OnlyNumber],
    declarations: [Treelist,Nodelist,TinyMceDirective,Tree, Node,DatePickerDirective,TimePickerDirective,OnlyNumber],
    providers: [AllAuthGuard],
})
export class CoreModule { 
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: CoreModule,
            providers: [AllAuthGuard,MenuService]
           
        };
    }
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/core.module.ts